import React from 'react';
import { Link } from 'react-router-dom';
import CollectorCard from '../passport/CollectorCard';
import { defaultCardDesign } from '../../services/api/passportCards';
import { formatPublicRosterCount } from '../../utils/registrationStatus';
import type { PublicRosterPayload } from '../../types/event';

interface EventPublicRosterProps {
  roster?: PublicRosterPayload | null;
}

const EventPublicRoster: React.FC<EventPublicRosterProps> = ({ roster }) => {
  const visibility = roster?.visibility || 'hidden';
  if (visibility === 'hidden') return null;

  const count = Number(roster?.count || 0);
  const headline = formatPublicRosterCount(count, roster?.capacity);
  const entries = visibility === 'list' ? roster?.entries || [] : [];

  return (
    <section className="mb-8" aria-labelledby="event-public-roster-heading">
      <h2 id="event-public-roster-heading" className="heading-section mb-3">
        Registered builds
      </h2>
      <p className="text-muted text-sm mb-4">{headline}</p>
      {visibility === 'list' ? (
        entries.length === 0 ? (
          <p className="text-muted text-sm">No confirmed builds yet.</p>
        ) : (
          <ul className="collector-grid">
            {entries.map((entry, index) => {
              const href =
                entry.owner_username && entry.public_slug
                  ? `/${entry.owner_username}/${entry.public_slug}`
                  : null;
              const subject = entry.collector_subject;
              if (subject)
                return (
                  <li key={`vehicle:${subject.subject_id}`}>
                    <CollectorCard
                      card={{
                        id: null,
                        title: subject.title,
                        subject_type: 'vehicle',
                        subject_id: subject.subject_id,
                        issuer: 'Bilt:Spec',
                        status: 'preview',
                        design: defaultCardDesign,
                        rules: { evidence: 'qr', cap: null },
                        subject,
                      }}
                      href={href || undefined}
                      fullRecordExtension={
                        entry.class_name ? <p>Registered class: {entry.class_name}</p> : undefined
                      }
                    />
                  </li>
                );
              const body = (
                <>
                  <p className="font-medium text-white">{entry.vehicle_label}</p>
                  <p className="text-sm text-gray-500 mt-0.5">
                    {entry.owner_username ? `@${entry.owner_username}` : 'Owner hidden'}
                    {entry.class_name ? ` · ${entry.class_name}` : ''}
                  </p>
                </>
              );
              return (
                <li key={`${entry.owner_username || 'build'}-${entry.vehicle_label}-${index}`}>
                  {href ? (
                    <Link
                      to={href}
                      className="block px-4 py-3.5 bg-[#0c0c0c]/40 hover:bg-[#141414] min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-500/50"
                    >
                      {body}
                    </Link>
                  ) : (
                    <div className="px-4 py-3.5 bg-[#0c0c0c]/40">{body}</div>
                  )}
                </li>
              );
            })}
          </ul>
        )
      ) : null}
    </section>
  );
};

export default EventPublicRoster;
